import script from "./AssetLibraryHoverPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetLibraryHoverPreview.vue?vue&type=script&setup=true&lang=js"

import "./AssetLibraryHoverPreview.vue?vue&type=style&index=0&id=61d19811&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d19811"]])

export default __exports__